"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDropdown = void 0;
const React = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const startCase_1 = __importDefault(require("lodash/startCase"));
const useClickOutside_1 = __importDefault(require("hooks/useClickOutside"));
const HelperUtils_1 = require("utils/HelperUtils");
const Divider_1 = __importDefault(require("components/design-system/Divider"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
require("./Dropdown.scss");
const DropdownContext = React.createContext(null);
DropdownContext.displayName = 'DropdownContext';
function Dropdown({ children, customClass, autoOpen = false }) {
    const [open, setOpen] = React.useState(autoOpen);
    const [animation, setAnimation] = React.useState(!autoOpen
        ? 'animation-close-dropdown-rotate'
        : 'animation-open-dropdown-fadeInDownSlow');
    const dropdown = () => {
        setAnimation(open
            ? 'animation-close-dropdown-rotate'
            : 'animation-open-dropdown-fadeInDownSlow');
        setTimeout(() => setOpen(!open), open ? 150 : 0);
    };
    const ref = React.useRef(null);
    return (React.createElement(DropdownContext.Provider, { value: { open, animation, setOpen: dropdown, ref } },
        React.createElement("div", { ref: ref, className: `relative inline-block text-left ${customClass ? customClass : ''}` }, children)));
}
const useDropdown = () => React.useContext(DropdownContext);
exports.useDropdown = useDropdown;
// enum type props
const FIXED_TYPE = 'fixed';
const ABS_TYPE = 'absolute';
function MenuItemsContent({ children, position = 'left', options, style, isParent = true, customClass, customContainerClass, type, vPosition = 'bottom', refChild, maxHeight, dataCy, id = '', setDialogOpen, useScrollClose, horizontalBased, onScroll, key, closeOnClick = true, disableSelected }) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { setOpen, animation, ref } = (0, exports.useDropdown)() || {};
    const [localRect, setLocalRect] = React.useState({ width: 0, height: 0 });
    const [startTriggerLeft] = React.useState(((_b = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.left) || 0);
    const [startTriggerBottom] = React.useState(((_d = (_c = ref === null || ref === void 0 ? void 0 : ref.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect()) === null || _d === void 0 ? void 0 : _d.bottom) || 0);
    const localRef = React.useRef(null);
    // if menu is the root menu then read open from context
    // if not read from props
    (0, useClickOutside_1.default)(ref, () => {
        closeOnClick && setOpen && setOpen();
        setDialogOpen && setDialogOpen();
    });
    const rect = (_e = ref === null || ref === void 0 ? void 0 : ref.current) === null || _e === void 0 ? void 0 : _e.getBoundingClientRect();
    const fixedPositionProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (position == 'left' && { left: rect === null || rect === void 0 ? void 0 : rect.left })), (position == 'middle' &&
        rect && {
        left: (rect === null || rect === void 0 ? void 0 : rect.left) + (rect === null || rect === void 0 ? void 0 : rect.width) / 2 - localRect.width / 2
    })), (position == 'right' && rect && { left: (rect === null || rect === void 0 ? void 0 : rect.right) - localRect.width })), (vPosition == 'top' &&
        rect && { top: (rect === null || rect === void 0 ? void 0 : rect.top) - 8 - (localRect === null || localRect === void 0 ? void 0 : localRect.height) })), (vPosition == 'bottom' && { top: rect === null || rect === void 0 ? void 0 : rect.bottom }));
    if (!isParent) {
        const rectChild = (_f = refChild === null || refChild === void 0 ? void 0 : refChild.current) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect();
        fixedPositionProps.right = 0;
        fixedPositionProps.top = rectChild === null || rectChild === void 0 ? void 0 : rectChild.top;
    }
    const fixedPositionStyle = Object.assign(Object.assign({}, (horizontalBased
        ? position == 'left'
            ? { left: 0 }
            : { right: 0 }
        : { left: fixedPositionProps.left })), { top: fixedPositionProps.top, zIndex: 100001 });
    const mergedStyle = Object.assign(Object.assign(Object.assign({}, style), (type == FIXED_TYPE && fixedPositionStyle)), {
        '--vertical-transform-origin': vPosition === 'bottom' ? 'top' : 'bottom'
    });
    const WrapperCN = ({ position, isParent, type }) => {
        return (0, classnames_template_literals_1.default)(`
      ${type != FIXED_TYPE && 'z-20'}
      ${type == ABS_TYPE
            ? `
        absolute
        ${vPosition === 'relative' && 'top-0'}
        ${vPosition === 'top' && 'top-0 -translate-y-full'}
        ${vPosition === 'bottom' && 'bottom-0 translate-y-full'}
        ${position === 'left' && 'left-0'}
        ${position === 'right' && 'right-0'}
        ${position === 'middle' && 'left-[50%] -translate-x-1/2'}
        ${!isParent && 'absolute top-0 translate-x-full'}
        min-w-full
        `
            : `
        fixed
        `}
    `);
    };
    const MenuCN = () => {
        return (0, classnames_template_literals_1.default)(`
    min-w-max
    shadow-raised
    rounded-md
    items-center
    bg-n-000
    mt-[2px]
    py-[8px]
    ${animation}
    ${customClass ? customClass : ''}
    `);
    };
    React.useEffect(() => {
        var _a;
        const rect = (_a = localRef === null || localRef === void 0 ? void 0 : localRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        setLocalRect({ width: (rect === null || rect === void 0 ? void 0 : rect.width) || 0, height: (rect === null || rect === void 0 ? void 0 : rect.height) || 0 });
        const eventScroll = () => {
            var _a, _b;
            const menuTop = (rect === null || rect === void 0 ? void 0 : rect.top) || 0;
            const menuLeft = (rect === null || rect === void 0 ? void 0 : rect.left) || 0;
            const triggerLeft = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left) || 0;
            const triggerBottom = ((_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().bottom) || 0;
            const differenceVertical = menuTop - triggerBottom;
            const differenceHorizontal = menuLeft - triggerLeft;
            if (startTriggerBottom / triggerBottom > 1 ||
                startTriggerBottom / triggerBottom < 0.98) {
                if (differenceVertical <= 0 || differenceVertical > 20) {
                    setOpen && setOpen();
                    setDialogOpen && setDialogOpen();
                }
            }
            if (startTriggerLeft / triggerLeft > 1.01 ||
                startTriggerLeft / triggerLeft < 0.996) {
                if (differenceHorizontal <= 0 || differenceHorizontal > 20) {
                    setOpen && setOpen();
                    setDialogOpen && setDialogOpen();
                }
            }
        };
        // Catch All scroll event inside <body/>, (3rd params set to true)
        if (type == FIXED_TYPE || useScrollClose) {
            document
                .getElementsByTagName('html')[0]
                .addEventListener('scroll', eventScroll, true);
        }
        return () => {
            if (type == FIXED_TYPE || useScrollClose) {
                document
                    .getElementsByTagName('html')[0]
                    .removeEventListener('scroll', eventScroll, true);
            }
        };
    }, []);
    return (React.createElement("div", { className: WrapperCN({
            position,
            isParent,
            type
        }), style: mergedStyle },
        React.createElement("div", { ref: localRef, className: MenuCN(), onScroll: (e) => {
                e.stopPropagation();
                onScroll && onScroll(e);
            }, id: id, onClick: (e) => e.stopPropagation(), key: key },
            React.createElement("div", { className: `py-[1px] ${customContainerClass ? customContainerClass : ''} ${maxHeight
                    ? ` overflow-hidden hover:overflow-overlay hover:overflow-auto`
                    : ''}`, style: maxHeight ? { maxHeight: maxHeight + 'px' } : {} }, options ? (React.createElement(React.Fragment, null,
                !Array.isArray(children) &&
                    ((_g = children === null || children === void 0 ? void 0 : children.props) === null || _g === void 0 ? void 0 : _g.index) === -1 &&
                    children, options === null || options === void 0 ? void 0 :
                options.map((_a, index) => {
                    var _b, _c, _d;
                    var { text, additionalText, disabled } = _a, props = __rest(_a, ["text", "additionalText", "disabled"]);
                    return (React.createElement(React.Fragment, { key: index },
                        Array.isArray(children) &&
                            ((_c = (_b = children === null || children === void 0 ? void 0 : children[index]) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.index) === index &&
                            children,
                        !Array.isArray(children) &&
                            ((_d = children === null || children === void 0 ? void 0 : children.props) === null || _d === void 0 ? void 0 : _d.index) === index &&
                            children,
                        React.createElement(MenuItem, Object.assign({}, props, { key: index, index: index, dataCyParent: dataCy, disabled: (0, startCase_1.default)(disableSelected) === text || disabled }),
                            React.createElement(React.Fragment, null,
                                text && (0, HelperUtils_1.getObjectiveLocale)(text),
                                additionalText))));
                }),
                !Array.isArray(children) &&
                    ((_h = children === null || children === void 0 ? void 0 : children.props) === null || _h === void 0 ? void 0 : _h.index) === undefined &&
                    children)) : (children)))));
}
function MenuItems(_a) {
    var { isParent = true, open = false, type = ABS_TYPE, dataCy = '', setDialogOpen, disableSelected } = _a, rest = __rest(_a, ["isParent", "open", "type", "dataCy", "setDialogOpen", "disableSelected"]);
    const { open: rootOpen } = (0, exports.useDropdown)() || {};
    const isOpen = isParent ? rootOpen : open;
    if (!isOpen)
        return null;
    if (type == FIXED_TYPE) {
        const sharedDropdown = document.querySelectorAll(`[id^=shared-dropdown]`)[0];
        return (React.createElement("div", { className: "is-portal" }, react_dom_1.default.createPortal(React.createElement(MenuItemsContent, Object.assign({ isParent: isParent, type: type, dataCy: dataCy, setDialogOpen: setDialogOpen }, rest)), sharedDropdown)));
    }
    return (React.createElement(MenuItemsContent, Object.assign({ isParent: isParent, type: type, dataCy: dataCy, setDialogOpen: setDialogOpen, disableSelected: disableSelected }, rest)));
}
function MenuItem({ children, onClick, onMouseEnter, onMouseLeave, iconName = '', iconColor = 'var(--n-600)', textColor = 'text-n-900', divider, customClass, index, dataCy, dataCyParent, disabled, useHover = true, closeOnClick = true }) {
    const { setOpen } = (0, exports.useDropdown)() || {};
    const [onHover, setOnHover] = React.useState(false);
    const MenuItemCN = (textColor, customClass) => {
        return (0, classnames_template_literals_1.default)(`
    flex
    px-[16px]
    min-h-[32px]
    items-center
    justify-between
    cursor-pointer
    relative
    ${disabled
            ? 'bg-n-300 text-n-600 cursor-not-allowed'
            : `bg-n-000 ${textColor}`}
    ${(onClick || onMouseEnter) &&
            !disabled &&
            useHover &&
            'hover:bg-base-30024'}
    ${customClass}
  `);
    };
    const ref = React.useRef(null);
    // for case multiple dropdown, usually we pass menu items in children props
    // and to open the menu items we need to pass props open to the component
    // hence we need to map the children
    // and if it's find a react component then we pass props open -- based on current hover state
    const childrenWithProps = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                open: onHover,
                refChild: ref
            });
        }
        return child;
    });
    const setOnClick = (e) => {
        if (disabled || !onClick)
            return;
        e.stopPropagation();
        onClick && onClick(e);
        closeOnClick && setOpen && setOpen(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: ref, onClick: (e) => setOnClick(e), className: MenuItemCN(textColor, customClass || ''), onMouseEnter: () => {
                setOnHover(true);
                onMouseEnter && onMouseEnter();
            }, onMouseLeave: () => {
                setOnHover(false);
                onMouseLeave && onMouseLeave();
            }, "data-cy": dataCy
                ? dataCy
                : dataCyParent
                    ? dataCyParent + '-option-' + index
                    : '' },
            React.createElement("div", { className: "flex items-center w-full" },
                iconName && (React.createElement(SVGIcon_1.default, { size: 24, customClass: "mr-[8px] fill-current", iconName: iconName, fillColor: disabled ? 'var(--n-600)' : iconColor })),
                childrenWithProps)),
        divider && React.createElement(Divider_1.default, { style: { marginTop: '4px', marginBottom: '4px' } })));
}
function Trigger({ children, customClass, dataCy, disabled = false, onClick, beforeTrigger, useHoverOpen }) {
    const { setOpen, open } = (0, exports.useDropdown)() || {};
    const setOnClick = (e) => {
        if (disabled || useHoverOpen)
            return;
        if (beforeTrigger) {
            beforeTrigger(e, setOpen);
        }
        else {
            e.stopPropagation();
            if (onClick) {
                onClick();
            }
            setOpen && setOpen();
        }
    };
    return (React.createElement("div", { className: `rounded-[4px] ${customClass} ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`, onClick: !disabled ? setOnClick : undefined, "data-cy": dataCy, onMouseOver: () => useHoverOpen && !open && setOpen && setOpen(), onMouseLeave: () => useHoverOpen && open && setOpen && setOpen() }, children));
}
Dropdown.displayName = 'Dropdown';
Dropdown.Trigger = Trigger;
Dropdown.MenuItem = MenuItem;
Dropdown.MenuItems = MenuItems;
exports.default = Dropdown;
